<div class="">
  <p-progress-spinner
    strokeWidth="8"
    fill="transparent"
    animationDuration=".5s"
    [style]="{ width: '50px', height: '50px' }"
  />
</div>
